/*eslint-disable*/
import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useGlobal } from "GlobalContext";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const { sharedValue } = useGlobal();

  const isAuthenticated = Boolean(sharedValue.id);

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

export default ProtectedRoute;